import React from 'react';
import { Button, PlayCircleIcon } from '@metarouter-private/mr-mui';

export default function SendEventButton(props) {
  return (
    <Button {...props} startIcon={<PlayCircleIcon />}>
      Send Event
    </Button>
  );
}
